import { useEffect, useRef, useState } from "react";
import "./Relocate.css";

const CITIES = [
  "Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune",
  "Chennai", "Kolkata", "Ahmedabad", "Noida", "Gurgaon",
  "Jaipur", "Kochi", "Chandigarh", "Indore", "Surat",
  "Lucknow", "Nagpur", "Coimbatore", "Mysore", "Vadodara",
];

const LOCALITIES_BY_CITY = {
  Bangalore: ["Koramangala", "HSR Layout", "Indiranagar", "Whitefield", "Electronic City"],
  Mumbai: ["Andheri", "Bandra", "Powai", "Thane", "Navi Mumbai"],
  Delhi: ["Saket", "Dwarka", "Rohini", "Lajpat Nagar", "Karol Bagh"],
  Hyderabad: ["Hitech City", "Gachibowli", "Kondapur", "Madhapur", "Banjara Hills"],
  Pune: ["Hinjewadi", "Kharadi", "Viman Nagar", "Baner", "Wakad"],
  Chennai: ["T. Nagar", "Velachery", "OMR", "Anna Nagar", "Adyar"],
  Kolkata: ["Salt Lake", "Park Street", "Ballygunge", "New Town", "Gariahat"],
  Ahmedabad: ["SG Highway", "Navrangpura", "Satellite", "Bopal", "Vastrapur"],
  Noida: ["Sector 62", "Sector 18", "Sector 75", "Sector 135", "Sector 137"],
  Gurgaon: ["Cyber City", "Golf Course Road", "Sohna Road", "MG Road", "Sector 29"],
};

const CATEGORIES = [
  { id: "tiffin", label: "Tiffin / Meal", icon: "Meal" },
  { id: "pg", label: "PG / Hostel", icon: "Stay" },
  { id: "furniture", label: "Rented Furniture", icon: "Home" },
  { id: "flatmate", label: "Flatmates", icon: "Share" },
  { id: "movers", label: "Movers & Packers", icon: "Move" },
  { id: "internet", label: "Broadband / SIM", icon: "Net" },
  { id: "gym", label: "Gym / Fitness", icon: "Fit" },
  { id: "laundry", label: "Laundry", icon: "Wash" },
];

const SERVICES = {
  tiffin: {
    label: "Tiffin & Meal Services",
    desc: "Homely, affordable meals delivered daily to your door.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Indiranagar", "Whitefield"],
      Mumbai: ["Andheri", "Bandra", "Powai"],
      Delhi: ["Saket", "Dwarka", "Lajpat Nagar"],
      Hyderabad: ["Hitech City", "Gachibowli", "Madhapur"],
      Pune: ["Hinjewadi", "Kharadi", "Viman Nagar"],
      Chennai: ["Velachery", "OMR", "Anna Nagar"],
      Noida: ["Sector 62", "Sector 75", "Sector 137"],
      Gurgaon: ["Cyber City", "Golf Course Road", "Sohna Road"],
    },
    sites: [
      { name: "Box8", url: "https://www.box8.in", tag: "App + Web", note: "Pan-India meal plans" },
      { name: "Swiggy Daily", url: "https://www.swiggy.com", tag: "Subscription", note: "Daily meal subscriptions" },
      { name: "Zomato", url: "https://www.zomato.com", tag: "App", note: "Find nearby tiffin centres" },
      { name: "TiffinWala", url: "https://www.tiffinwala.com", tag: "Tiffin", note: "Home-cooked tiffin service" },
      { name: "MealPe", url: "https://www.mealpe.in", tag: "Subscription", note: "Monthly meal plans" },
      { name: "Scootsy", url: "https://www.scootsy.com", tag: "Delivery", note: "Premium tiffin delivery" },
    ],
  },
  pg: {
    label: "PG & Hostel Finder",
    desc: "Safe, affordable paying guest accommodations near your workplace.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon", "Kolkata"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Whitefield", "Electronic City"],
      Mumbai: ["Andheri", "Powai", "Thane"],
      Delhi: ["Saket", "Dwarka", "Rohini"],
      Hyderabad: ["Hitech City", "Kondapur", "Madhapur"],
      Pune: ["Hinjewadi", "Baner", "Wakad"],
      Chennai: ["Velachery", "OMR", "Adyar"],
      Noida: ["Sector 62", "Sector 75", "Sector 137"],
      Gurgaon: ["Cyber City", "Sector 29", "Sohna Road"],
      Kolkata: ["Salt Lake", "New Town", "Park Street"],
    },
    sites: [
      { name: "NoBroker PG", url: "https://www.nobroker.in/pg", tag: "No Brokerage", note: "Zero brokerage PG listings" },
      { name: "Stanza Living", url: "https://stanzaliving.com", tag: "Premium PG", note: "Fully managed co-living" },
      { name: "OYO Life", url: "https://www.oyorooms.com/life", tag: "Managed PG", note: "Long-stay managed PGs" },
      { name: "Magicbricks", url: "https://www.magicbricks.com/pg-in-bangalore.html", tag: "Listing", note: "Huge PG database" },
      { name: "99acres PG", url: "https://www.99acres.com", tag: "Listing", note: "Verified PG listings" },
      { name: "Zolo Stays", url: "https://zolostays.com", tag: "Co-living", note: "Community co-living spaces" },
    ],
  },
  furniture: {
    label: "Rented Furniture",
    desc: "Furnish your new home without the big upfront investment.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon", "Kolkata", "Ahmedabad"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Whitefield"],
      Mumbai: ["Andheri", "Powai", "Bandra"],
      Delhi: ["Saket", "Dwarka", "Lajpat Nagar"],
      Hyderabad: ["Hitech City", "Gachibowli", "Madhapur"],
      Pune: ["Hinjewadi", "Kharadi", "Baner"],
      Chennai: ["Velachery", "OMR", "Anna Nagar"],
      Noida: ["Sector 62", "Sector 75"],
      Gurgaon: ["Cyber City", "Sector 29"],
      Kolkata: ["Salt Lake", "New Town"],
      Ahmedabad: ["SG Highway", "Satellite"],
    },
    sites: [
      { name: "RentoMojo", url: "https://www.rentomojo.com", tag: "Top Pick", note: "Furniture and appliance rental" },
      { name: "Furlenco", url: "https://www.furlenco.com", tag: "Premium", note: "Stylish furniture on rent" },
      { name: "Cityfurnish", url: "https://www.cityfurnish.com", tag: "Affordable", note: "Budget furniture rental" },
      { name: "GrabOnRent", url: "https://www.grabonrent.com", tag: "Gadgets+", note: "Furniture and electronics rent" },
      { name: "Fabrento", url: "https://www.fabrento.com", tag: "Flexible", note: "Flexible tenure rentals" },
      { name: "AnyTimeFurnish", url: "https://www.anytimefurnish.com", tag: "Delivery", note: "Same-day furniture delivery" },
    ],
  },
  flatmate: {
    label: "Flatmate Finder",
    desc: "Find verified, compatible flatmates to split rent and living costs.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon", "Kolkata", "Ahmedabad"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Indiranagar"],
      Mumbai: ["Andheri", "Bandra", "Powai"],
      Delhi: ["Saket", "Dwarka", "Rohini"],
      Hyderabad: ["Hitech City", "Madhapur", "Kondapur"],
      Pune: ["Hinjewadi", "Baner", "Wakad"],
      Chennai: ["Velachery", "OMR", "Anna Nagar"],
      Noida: ["Sector 62", "Sector 75"],
      Gurgaon: ["Cyber City", "MG Road", "Sector 29"],
      Kolkata: ["Salt Lake", "New Town"],
      Ahmedabad: ["Satellite", "Bopal"],
    },
    sites: [
      { name: "Flatmate.in", url: "https://www.flatmate.in", tag: "Verified", note: "Large flatmate network" },
      { name: "NoBroker", url: "https://www.nobroker.in", tag: "No Fee", note: "Zero brokerage flat sharing" },
      { name: "Sulekha", url: "https://www.sulekha.com/flats-for-rent", tag: "Local", note: "City-wise flat listings" },
      { name: "OLX Housing", url: "https://www.olx.in/real-estate", tag: "Free", note: "Peer-to-peer listings" },
      { name: "SpareRoom", url: "https://www.spareroom.co.in", tag: "Community", note: "Room and flatmate search" },
      { name: "QuikrHomes", url: "https://homes.quikr.com", tag: "Verified", note: "Verified rental listings" },
    ],
  },
  movers: {
    label: "Movers & Packers",
    desc: "Reliable packing and moving services for a stress-free relocation.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon", "Kolkata", "Ahmedabad", "Jaipur", "Kochi", "Chandigarh", "Indore", "Surat"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Whitefield"],
      Mumbai: ["Andheri", "Powai", "Thane"],
      Delhi: ["Saket", "Dwarka", "Rohini"],
      Hyderabad: ["Hitech City", "Gachibowli", "Madhapur"],
      Pune: ["Hinjewadi", "Baner", "Kharadi"],
      Chennai: ["Velachery", "OMR", "Adyar"],
      Noida: ["Sector 62", "Sector 75"],
      Gurgaon: ["Cyber City", "Sector 29", "Sohna Road"],
      Kolkata: ["Salt Lake", "New Town"],
      Ahmedabad: ["SG Highway", "Satellite"],
    },
    sites: [
      { name: "Urban Company", url: "https://www.urbancompany.com/packers-and-movers", tag: "Trusted", note: "Background-verified movers" },
      { name: "Sulekha Movers", url: "https://www.sulekha.com/packers-and-movers", tag: "Compare", note: "Compare quotes easily" },
      { name: "Agarwal Packers", url: "https://www.agarwalpackers.com", tag: "Legacy", note: "50+ years of experience" },
      { name: "Porter", url: "https://porter.in", tag: "Quick", note: "On-demand truck booking" },
      { name: "Pikkol", url: "https://www.pikkol.com", tag: "Tech", note: "Tech-first moving service" },
      { name: "Bygging.in", url: "https://www.bygging.in", tag: "Budget", note: "Transparent pricing" },
    ],
  },
  internet: {
    label: "Broadband & SIM Cards",
    desc: "Get connected fast. Home internet and mobile SIMs sorted.",
    cities: CITIES,
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Indiranagar", "Whitefield"],
      Mumbai: ["Andheri", "Bandra", "Powai"],
      Delhi: ["Saket", "Dwarka", "Lajpat Nagar"],
      Hyderabad: ["Hitech City", "Gachibowli", "Madhapur"],
      Pune: ["Hinjewadi", "Baner", "Kharadi"],
      Chennai: ["Velachery", "OMR", "Anna Nagar"],
      Noida: ["Sector 62", "Sector 75"],
      Gurgaon: ["Cyber City", "Sector 29"],
      Kolkata: ["Salt Lake", "New Town"],
      Ahmedabad: ["SG Highway", "Satellite"],
    },
    sites: [
      { name: "ACT Fibernet", url: "https://www.actcorp.in", tag: "Broadband", note: "High-speed fiber broadband" },
      { name: "Airtel Xstream", url: "https://www.airtel.in/broadband", tag: "Broadband", note: "Airtel home broadband" },
      { name: "Jio Fiber", url: "https://www.jio.com/fiber", tag: "Affordable", note: "Budget fiber plans" },
      { name: "BSNL Broadband", url: "https://www.bsnl.co.in", tag: "Govt", note: "Government broadband" },
      { name: "Tata Play Fiber", url: "https://www.tataplayfiber.com", tag: "Premium", note: "OTT bundled plans" },
      { name: "Excitel", url: "https://www.excitel.com", tag: "Budget", note: "Affordable fiber plans" },
    ],
  },
  gym: {
    label: "Gym & Fitness",
    desc: "Stay fit in your new city with gyms, yoga studios, and fitness apps.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon", "Kolkata", "Ahmedabad", "Jaipur"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Indiranagar"],
      Mumbai: ["Andheri", "Bandra", "Powai"],
      Delhi: ["Saket", "Dwarka", "Rohini"],
      Hyderabad: ["Hitech City", "Gachibowli", "Madhapur"],
      Pune: ["Hinjewadi", "Baner", "Kharadi"],
      Chennai: ["Velachery", "OMR", "Anna Nagar"],
      Noida: ["Sector 62", "Sector 75"],
      Gurgaon: ["Cyber City", "Sector 29"],
      Kolkata: ["Salt Lake", "New Town"],
      Ahmedabad: ["Satellite", "SG Highway"],
    },
    sites: [
      { name: "Cult.fit", url: "https://www.cult.fit", tag: "Top Pick", note: "Gyms, yoga and HIIT classes" },
      { name: "Fitternity", url: "https://www.fitternity.com", tag: "Passes", note: "Multi-gym membership passes" },
      { name: "Gold's Gym", url: "https://www.goldsgym.in", tag: "Premium", note: "Premium gym chain" },
      { name: "Anytime Fitness", url: "https://www.anytimefitness.co.in", tag: "24/7", note: "Round-the-clock access" },
      { name: "YogaBar", url: "https://www.yogabar.com", tag: "Wellness", note: "Yoga and wellness classes" },
      { name: "HealthifyMe", url: "https://www.healthifyme.com", tag: "App", note: "Diet and workout tracking" },
    ],
  },
  laundry: {
    label: "Laundry Services",
    desc: "Doorstep laundry and dry-cleaning pickup services.",
    cities: ["Bangalore", "Mumbai", "Delhi", "Hyderabad", "Pune", "Chennai", "Noida", "Gurgaon", "Kolkata", "Ahmedabad", "Jaipur", "Kochi", "Chandigarh", "Indore"],
    localitiesByCity: {
      Bangalore: ["Koramangala", "HSR Layout", "Indiranagar"],
      Mumbai: ["Andheri", "Bandra", "Powai"],
      Delhi: ["Saket", "Dwarka", "Rohini"],
      Hyderabad: ["Hitech City", "Madhapur", "Gachibowli"],
      Pune: ["Hinjewadi", "Baner", "Kharadi"],
      Chennai: ["Velachery", "OMR", "Anna Nagar"],
      Noida: ["Sector 62", "Sector 75"],
      Gurgaon: ["Cyber City", "Sector 29"],
      Kolkata: ["Salt Lake", "New Town"],
      Ahmedabad: ["SG Highway", "Satellite"],
    },
    sites: [
      { name: "Urban Company Laundry", url: "https://www.urbancompany.com/laundry", tag: "Trusted", note: "Doorstep laundry pickup" },
      { name: "UClean", url: "https://www.uclean.in", tag: "Chain", note: "Large outlet network" },
      { name: "Wassup Laundry", url: "https://www.wassup.in", tag: "App", note: "On-demand laundry app" },
      { name: "Laundrywala", url: "https://www.laundrywala.com", tag: "Express", note: "Fast turnaround service" },
      { name: "Mr. Cloth", url: "https://www.mrcloth.in", tag: "Budget", note: "Affordable dry cleaning" },
      { name: "Cleanly", url: "https://www.cleanly.co.in", tag: "Premium", note: "Premium garment care" },
    ],
  },
};

const TIPS = [
  { title: "Make a checklist", body: "List PG, SIM, rent, food, and commute before the move." },
  { title: "Scout the locality", body: "Check distance to office, metro, and markets before booking anything." },
  { title: "Join local groups", body: "City groups help you find local deals and verified recommendations." },
  { title: "Negotiate rent", body: "A little negotiation can often save 5 to 10 percent on move-in costs." },
];

function norm(value) {
  return (value ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}

function matchesText(value, candidate) {
  return norm(value) === norm(candidate);
}

function fuzzyMatch(query, list) {
  if (!query) return [];
  const q = norm(query);
  return list.filter(item => norm(item).includes(q)).slice(0, 8);
}

function getCityKey(city) {
  return CITIES.find(item => matchesText(item, city)) || "";
}

function getLocalityOptions(city) {
  const key = getCityKey(city);
  return key ? (LOCALITIES_BY_CITY[key] || []) : [];
}

function siteMatchesLocation(site, service, city, locality) {
  if (!city) return true;

  const cityKey = getCityKey(city);
  const allowedCities = site.cities || service.cities || [];
  if (allowedCities.length && !allowedCities.some(item => matchesText(item, cityKey || city))) {
    return false;
  }

  if (!locality) return true;

  const localityMap = site.localitiesByCity || service.localitiesByCity || {};
  const localityList = localityMap[cityKey] || localityMap[city] || [];
  if (!localityList.length) return true;

  return localityList.some(item => matchesText(item, locality));
}

function visibleSites(service, city, locality) {
  return service.sites.filter(site => siteMatchesLocation(site, service, city, locality));
}

function SearchField({
  value,
  onChange,
  onSelect,
  placeholder,
  icon,
  suggestions,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className={`rh-field-wrap${disabled ? " rh-field-wrap--disabled" : ""}`}>
      <div className="rh-field">
        <span className="rh-field__icon">{icon}</span>
        <input
          className="rh-field__input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={e => {
            onChange(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          autoComplete="off"
          disabled={disabled}
        />
        {value && !disabled && (
          <button
            type="button"
            className="rh-field__clear"
            onMouseDown={e => {
              e.preventDefault();
              onChange("");
              onSelect("");
            }}
          >
            x
          </button>
        )}
      </div>
      {open && !disabled && suggestions.length > 0 && (
        <div className="rh-dropdown">
          <div className="rh-dropdown__label">Suggestions</div>
          {suggestions.map(item => (
            <button
              key={item}
              type="button"
              className="rh-dropdown__item"
              onMouseDown={e => {
                e.preventDefault();
                onSelect(item);
                onChange(item);
                setOpen(false);
              }}
            >
              <span className="rh-dropdown__bullet">•</span>
              <span>{item}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function ServiceCard({ site, index, city, locality }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.12 });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const coverage = city
    ? locality
      ? `Works in ${locality}, ${city}`
      : `Available in ${city}`
    : site.cities?.length
      ? `${site.cities.length}+ cities`
      : "Pan-India";

  return (
    <article
      ref={ref}
      className={`rh-card${visible ? " rh-card--visible" : ""}`}
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="rh-card__top">
        <div>
          <div className="rh-card__name">{site.name}</div>
          <div className="rh-card__tag">{site.tag}</div>
        </div>
        <div className="rh-card__coverage">{coverage}</div>
      </div>
      <p className="rh-card__note">{site.note}</p>
      <a href={site.url} target="_blank" rel="noopener noreferrer" className="rh-card__btn">
        Visit site <span>→</span>
      </a>
    </article>
  );
}

function CategoryPanel({ categoryId, city, locality }) {
  const service = SERVICES[categoryId];
  if (!service) return null;

  const sites = visibleSites(service, city, locality);
  const resolvedCity = getCityKey(city) || city;

  return (
    <section className="rh-panel">
      <div className="rh-panel__head">
        <div>
          <h2 className="rh-panel__title">{service.label}</h2>
          <p className="rh-panel__desc">
            {service.desc}
            {city && (
              <span className="rh-panel__city-note">
                {" "}Showing options for <strong>{resolvedCity}</strong>
                {locality ? <> / <strong>{locality}</strong></> : null}.
              </span>
            )}
          </p>
        </div>
        <div className="rh-panel__count">{sites.length} websites</div>
      </div>

      {sites.length > 0 ? (
        <div className="rh-grid">
          {sites.map((site, index) => (
            <ServiceCard key={site.name} site={site} index={index} city={resolvedCity} locality={locality} />
          ))}
        </div>
      ) : (
        <div className="rh-empty-state">
          <div className="rh-empty-state__title">No websites mapped for this area yet</div>
          <div className="rh-empty-state__body">
            Try a nearby locality or switch to a broader city search.
          </div>
        </div>
      )}
    </section>
  );
}

export default function RelocateHub() {
  const [city, setCity] = useState("");
  const [locality, setLocality] = useState("");
  const [categoryId, setCategoryId] = useState("tiffin");
  const [heroReady, setHeroReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setHeroReady(true), 80);
    return () => clearTimeout(timer);
  }, []);

  const resolvedCity = getCityKey(city) || city;
  const citySuggestions = city ? fuzzyMatch(city, CITIES) : CITIES.slice(0, 8);
  const localityOptions = getLocalityOptions(city);
  const localitySuggestions = locality
    ? fuzzyMatch(locality, localityOptions)
    : localityOptions.slice(0, 8);

  const activeService = SERVICES[categoryId];
  const matchedSites = activeService ? visibleSites(activeService, city, locality) : [];
  const activeMeta = [
    city ? resolvedCity : "Any city",
    locality ? locality : "Any locality",
    `${matchedSites.length} websites`,
  ];

  const handleCitySelect = (value) => {
    setCity(value);
    setLocality("");
    document.getElementById("rh-results")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleLocalitySelect = (value) => {
    setLocality(value);
    document.getElementById("rh-results")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="rh-root">
      <section className={`rh-hero${heroReady ? " rh-hero--ready" : ""}`}>
        <div className="rh-hero__glow rh-hero__glow--one" />
        <div className="rh-hero__glow rh-hero__glow--two" />
        <div className="rh-hero__inner">
          <div className="rh-hero__eyebrow">Relocation made simple</div>
          <h1 className="rh-hero__title">
            Find websites that work in your city and locality.
          </h1>
          <p className="rh-hero__sub">
            Pick a city and area, then see the services and websites that are most useful there.
          </p>

          <div className="rh-searchbar">
            <SearchField
              value={city}
              onChange={setCity}
              onSelect={handleCitySelect}
              placeholder="Search your city"
              icon="📍"
              suggestions={citySuggestions}
            />
            <SearchField
              value={locality}
              onChange={setLocality}
              onSelect={handleLocalitySelect}
              placeholder={city ? "Search locality or area" : "Choose a city first"}
              icon="🏘"
              suggestions={localitySuggestions}
              disabled={!city.trim()}
            />
            <button type="button" className="rh-searchbar__btn" onClick={handleCitySelect.bind(null, city.trim())}>
              Show sites
            </button>
          </div>

          <div className="rh-chip-row">
            {["Bangalore", "Mumbai", "Pune", "Hyderabad", "Delhi"].map(item => (
              <button
                key={item}
                type="button"
                className={`rh-chip${matchesText(item, city) ? " rh-chip--active" : ""}`}
                onClick={() => handleCitySelect(item)}
              >
                {item}
              </button>
            ))}
          </div>

          <div className="rh-stats">
            {activeMeta.map(item => (
              <div key={item} className="rh-stat">
                <strong>{item}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rh-main" id="rh-results">
        <div className="rh-shell">
          <aside className="rh-sidebar">
            <div className="rh-sidebar__label">Browse by need</div>
            {CATEGORIES.map(category => (
              <button
                key={category.id}
                type="button"
                className={`rh-sidebar__btn${categoryId === category.id ? " rh-sidebar__btn--active" : ""}`}
                onClick={() => setCategoryId(category.id)}
              >
                <span className="rh-sidebar__icon">{category.icon}</span>
                <span>{category.label}</span>
              </button>
            ))}
          </aside>

          <div className="rh-content">
            <div className="rh-banner">
              <span className="rh-banner__dot" />
              <span>
                {city ? (
                  <>Showing websites for <strong>{resolvedCity}</strong>{locality ? <> / <strong>{locality}</strong></> : null}</>
                ) : (
                  <>Choose a city to narrow down the websites that are active there.</>
                )}
              </span>
            </div>

            <CategoryPanel categoryId={categoryId} city={city.trim()} locality={locality.trim()} />
          </div>
        </div>
      </section>

      <section className="rh-tips">
        <div className="rh-section-head">
          <div className="rh-section-head__eyebrow">Pro tips</div>
          <h2>Keep these in mind while relocating</h2>
        </div>
        <div className="rh-tips__grid">
          {TIPS.map(tip => (
            <article key={tip.title} className="rh-tip">
              <h3>{tip.title}</h3>
              <p>{tip.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="rh-cta">
        <div>
          <h2>Found your area? Now find your job.</h2>
          <p>Use the city match to narrow down your next move, then continue to open roles.</p>
        </div>
        <a href="/employee/jobs" className="rh-cta__btn">Explore jobs →</a>
      </section>
    </div>
  );
}
